import { useTranslation } from "react-i18next";

import { Navigation } from "swiper/modules";

import { useBlogSelectors } from "../../../../../store/blog/blog.selectors";

import { Container } from "../../../../../components";
import { Slider } from "../../../../../components";

import { Section } from "../../../../../components/common/Section/Section.styled";

export const FactsModule = () => {
  const { t } = useTranslation();
  const { allFacts } = useBlogSelectors();

  const sliderSettings = {
    spaceBetween: 20,
    slidesPerView: "auto",
    modules: [Navigation],
  };

  if (allFacts.length === 0) return null;

  return (
    <Section>
      <Container isSlider>
        <Slider
          data-testing-id={"slider"}
          title={t("global.factsTitle")}
          buttons={true}
          settings={sliderSettings}
          type="mainPage"
          facts={allFacts}
          mainpage={+true}
          getshorter={+true}
        />
      </Container>
    </Section>
  );
};
